import z from "zod"

export const TableDragMetaSchema = z.object({
  index: z.number(),
  level: z.number(),
  parentID: z.string().nullable(),
  depth: z.number()
})

export type TableDragMeta = z.infer<typeof TableDragMetaSchema>
